module.exports = __webpack_public_path__ + "static/fonts/Fact-ExpandedExtraBold.cdf5055.ttf";